import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {Background} from '@mintdata/mint-kit/api/models/background/Background';
import {Border} from '@mintdata/mint-kit/api/models/Border';
import {BoxShadow} from '@mintdata/mint-kit/api/models/BoxShadow';
import {Font} from '@mintdata/mint-kit/api/models/Font';
import {BindingConfig, BindingIconPlace, BindingTooltipPlace} from '@mintdata/mint-kit/api/properties/BindingConfig';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {BeanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/BeanConfig';
import {FontConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/FontConfig';

export class ComponentState
{
    @Property<ABoolean>({
        title: 'Enabled',
        tip: 'Enabled',
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean,
        binding: BindingConfig.with(null, BindingIconPlace.RightMiddle, BindingTooltipPlace.Right)
    })
    isEnabled:ABoolean;

    @Property<Font>({
        title: 'Font',
        tip: 'Font',
        isRequired: false,
        typeConfig: FontConfig,
        typeCtor: Font
    })
    font:Font = null;

    @Property<Background>({
        title: 'Background',
        tip: 'Background',
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: Background
    })
    background:Background = null;

    @Property<Border>({
        title: 'Border',
        tip: 'Border',
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: Border
    })
    border:Border = null;

    @Property<BoxShadow>({
        title: 'Shadows',
        tip: 'Shadows',
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: BoxShadow
    })
    boxShadow:BoxShadow = null;

    public static default():ComponentState
    {
        const componentState:ComponentState = new ComponentState();

        componentState.isEnabled = ABoolean.false();
        componentState.font = Font.default();
        componentState.background = Background.default();
        componentState.border = Border.default();
        componentState.boxShadow = BoxShadow.default();

        return componentState;
    }
}
